var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogWrap"},[_c('div',[(_vm.url)?_c('vue-qr',{staticClass:"qrStyle",staticStyle:{"display":"block","width":"300px"},attrs:{"text":_vm.url}}):_c('p',{staticClass:"noDataStyle"},[_vm._v("加载中")]),_c('div',{staticClass:"dialog-footer"},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }